import { LabMDM } from './lab';
import { OperetionHistoryDTO } from './operationHistory';

export class ProcessType{
    _id: string;
    name:string;
    lab:LabMDM;
    active:boolean;
    history:OperetionHistoryDTO[];
}